import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent } from '@material-ui/core';
import {
  Button,
  Dialog,
  Flex,
  TextField,
} from '@knockrentals/knock-shared-web-v2';
import { useCustomLink } from './use-custom-link';
import { CUSTOM_LINK_FIELDS } from '../../../../../../constants';
import { CUSTOM_LINK_LABELS } from './constants';

const { TITLE, URL } = CUSTOM_LINK_FIELDS;

const CustomLink = ({
  closeDialog,
  onSaveCustomLink,
  primaryButtonText,
  title,
  url,
}) => {
  const {
    clearValidationErrorMessage,
    customLink,
    handleSaveLinkOnClick,
    isSaveButtonDisabled,
    updateCustomLink,
    validationErrorMessages,
  } = useCustomLink({
    closeDialog,
    onSaveCustomLink,
    title,
    url,
  });

  const handleOnBlur = (e) => {
    const { name, value } = e.target;
    updateCustomLink({ [name]: value.trim() });
  };

  const handleOnChange = (value, e) => {
    const { name } = e.target;
    updateCustomLink({ [name]: value });
  };

  const handleOnFocus = (e) => {
    clearValidationErrorMessage(e.target.name);
  };
  return (
    <React.Fragment>
      <DialogContent>
        <Flex flexDirection="column" gap={16}>
          <TextField
            error={Boolean(validationErrorMessages[TITLE])}
            helperText={validationErrorMessages[TITLE]}
            id={TITLE}
            label={CUSTOM_LINK_LABELS[TITLE]}
            name={TITLE}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            onFocus={handleOnFocus}
            placeholder="Website name"
            value={customLink[TITLE] || ''}
            variant="outlined"
          />

          <TextField
            error={Boolean(validationErrorMessages[URL])}
            helperText={validationErrorMessages[URL]}
            id={URL}
            label={CUSTOM_LINK_LABELS[URL]}
            name={URL}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            onFocus={handleOnFocus}
            placeholder="https://"
            value={customLink[URL] || ''}
            variant="outlined"
          />
        </Flex>
      </DialogContent>

      <Dialog.Actions>
        <Flex justifyContent="space-between" width="100%">
          <Button onClick={closeDialog} variant="text">
            Cancel
          </Button>

          <Button
            disabled={isSaveButtonDisabled}
            onClick={handleSaveLinkOnClick}
          >
            {primaryButtonText}
          </Button>
        </Flex>
      </Dialog.Actions>
    </React.Fragment>
  );
};

CustomLink.propTypes = {
  closeDialog: PropTypes.func,
  onSaveCustomLink: PropTypes.func,
  primaryButtonText: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default CustomLink;
